import DynamicSearch from '~/components/dynamic_search/dynamic_search'
import ReactController from '~/controllers/react_controller'

export default class DynamicSearchController extends ReactController {
  static values = {
    fields: Array,
    pollingInterval: Number,
    polling: Boolean,
    exportOptions: Object,
    sortOptions: Object,
  }

  createComponent() {
    this.performPolling()

    const supportedExports = ['csv']

    const enabledExports = Object.keys(this.exportOptionsValue).filter((format) => {
      return supportedExports.includes(format) && this.exportOptionsValue[format] === true
    })

    const submit = (format) => {
      if (format && enabledExports.includes(format)) {
        this.element.dataset.turbo = false

        // extract sort and dir from turboFrame src and set to form
        const turboFrameId = this.element.dataset.turboFrame
        const turboFrameSrc = document.getElementById(turboFrameId)?.getAttribute('src')
        if (turboFrameSrc) {
          const url = new URL(turboFrameSrc)
          const searchParams = url.searchParams
          this.element.querySelector('input[name="sort"]').value = searchParams.get('sort')
          this.element.querySelector('input[name="dir"]').value = searchParams.get('dir')
        }
      } else {
        this.element.dataset.turbo = true
      }

      return this.element.requestSubmit()
    }

    return (
      <DynamicSearch
        fields={this.fieldsValue}
        onChange={submit}
        exportOptions={this.exportOptionsValue}
        sortOptions={this.sortOptionsValue}
      />
    )
  }

  performPolling() {
    if (this.pollingValue) {
      this.element.requestSubmit()
      setTimeout(() => this.performPolling(), this.pollingIntervalValue)
    }
  }
}
